<script>
  import _ from 'lodash'
  import VueTypes from 'vue-types'
  import QuestionField from '../components/question-field'

  export default {
    template: '#questions-form-template',
    name: 'QuestionsForm',
    components: {
      'question-field': QuestionField,
    },
    props: {
      initMainGrowthRate: VueTypes.number.def(0),
      initSubGrowthRate: VueTypes.number.def(0),
      initformIndex: VueTypes.number.def(0),
    },
    data () {
      return {
        mainSellVolume: 0,
        subSellVolume: 0,
        mainGrowthRate: 0,
        subGrowthRate: 0,
        formIndex: this.initformIndex,
        children: null
      }
    },
    mounted () {
      this.children = this.getChildrenQuestionField()
      this.mainGrowthRate = this.initMainGrowthRate
      this.subGrowthRate = this.initSubGrowthRate
    },
    emits: ['formChange'],
    methods: {
      onAnswerChange (answer) {
        // 回答による表示非表示の切り替え
        const currentQuestion = answer.$parent
        if (this.children === null) {
          this.children = this.getChildrenQuestionField()
          if (!this.children) return
        }
        const otherQuestions = _.reject(this.children, currentQuestion)

        // いずれかの条件を満たしていれば表示
        _.forEach(otherQuestions, (question) => {
          if (_.isEmpty(question.premiseQuestions)) {
            question.show = true
          } else {
            question.show = _.some(question.premiseQuestions, (premiseQuestion) => {
              if (premiseQuestion.question === currentQuestion.id) {
                if (answer.inputType === 'checkbox') {
                  premiseQuestion.satisfied = _.includes(answer.checkedValues, _.toString(premiseQuestion.option))
                } else {
                  premiseQuestion.satisfied = (premiseQuestion.option === _.toInteger(answer.value))
                }
              }

              return premiseQuestion.satisfied
            })
          }
        })

        this.$nextTick(function () {
          this.$emit('form-change', this)
        })
      },

      applyMainGrowth () {
        // 年間予定販売数(月単位)(主) の自動入力
        this.answer(271, (answers, question) => {
          let val = this.mainSellVolume

          if (val === null) {
            return
          }
          val = this.toNumber(_.toString(val).replace(/,/g, ''))

          const answersChildren = []
          const keys = Object.keys(question.$refs)
          for ( let i = 0; i < keys.length; i++) {
            const key = keys[i]
            if (key.startsWith('answerField')) {
              answersChildren.push(question.$refs[key])
            }
          }

          const results = _.reduce(_.range(1, 36), (r, i) => {
            const b = r[i - 1]
            r.push(b * (1 + this.mainGrowthRate / 100.0))
            return r
          }, [val])

          // apply
          let invalid = false
          if (answersChildren.length === 36) {
            _.forEach(answersChildren, (answer, i) => {
              const v = Math.round(results[i])
              invalid = invalid || _.isNaN(v)
              if (!invalid) {
                answer.value = Math.round(results[i])
              }
            })

            if (invalid) {
              alert('数値で入力してください。')
            } else {
              this.$emit('form-change', this)
            }
          }
        })
      },

      applySubGrowth () {
        this.answer(291, (answers, question) => {
          let val = this.subSellVolume

          const answersChildren = []
          const keys = Object.keys(question.$refs)
          for ( let i = 0; i < keys.length; i++) {
            const key = keys[i]
            if (key.startsWith('answerField')) {
              answersChildren.push(question.$refs[key])
            }
          }
          if (val === null) {
            return
          }
          val = this.toNumber(_.toString(val).replace(/,/g, ''))

          const results = _.reduce(_.range(1, 36), (r, i) => {
            const b = r[i - 1]
            r.push(b * (1 + this.subGrowthRate / 100.0))
            return r
          }, [val])

          // apply
          let invalid = false
          if (answersChildren.length === 36) {
            _.forEach(answersChildren, (answer, i) => {
              const v = Math.round(results[i])
              invalid = invalid || _.isNaN(v)
              if (!invalid) {
                answer.value = Math.round(results[i])
              }
            })

            if (invalid) {
              alert('数値で入力してください。')
            } else {
              this.$emit('form-change', this)
            }
          }
        })
      },

      answer (questionId, callback) {
        const question = _.find(this.children, { id: questionId })
        if (question) {
          if (callback) {
            callback(question.children, question)
          } else {
            return question.children
          }
        }
      },

      isVisible (answers, index) {
        return _.get(answers, [index, 'show'])
      },

      getValue (answers, index, defaultValue = '') {
        return _.get(answers, [index, 'value'], defaultValue)
      },

      toNumber (val) {
        return ('' + val).replace(/[０-９]/g, (s) => String.fromCharCode(s.charCodeAt(0) - 0xFEE0))
      },

      formatDelimited (val) {
        const v = _.toString(val).replace(/,/g, '')
        if ( /^[+|-]?(\d*)(\.\d+)?$/.test(v) ) {
          return v.split('.')[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        } else {
          return val
        }
      },
      getChildrenQuestionField() {
        const children = []
        const keys = Object.keys(this.$refs)
        for ( let i = 0; i < keys.length; i++) {
          const key = keys[i]
          if (key.startsWith('questionField')) {
            children.push(this.$refs[key])
          }
        }
        return children
      },

    },

    // watch: {
    //   mainSellVolume (val) {
    //     this.mainSellVolume = this.formatDelimited(this.toNumber(val))
    //   },
    //   subSellVolume (val) {
    //     this.subSellVolume = this.formatDelimited(this.toNumber(val))
    //   },
    //   mainGrowthRate (val) {
    //     this.mainGrowthRate = this.toNumber(val)
    //   },
    //   subGrowthRate (val) {
    //     this.subGrowthRate = this.toNumber(val)
    //   },
    // }

    watch: {
      mainSellVolume: {
        handler (val) {
          this.mainSellVolume = this.formatDelimited(this.toNumber(val))
        }
      },
      subSellVolume: {
        handler (val) {
          this.subSellVolume = this.formatDelimited(this.toNumber(val))
        }
      },
      mainGrowthRate: {
        handler (val) {
          this.mainGrowthRate = this.toNumber(val)
        }
      },
      subGrowthRate: {
        handler (val) {
          this.subGrowthRate = this.toNumber(val)
        }
      },
      formIndex: {
        immediate: true
      },
    }


  }
</script>
